// @flow
import { createSelector } from "reselect"
import type { FetchedCurrencies } from "@kiwicom/nitro/lib/records/Currency"

type State = {
  currencies: FetchedCurrencies,
}

export default function CurrenciesReducer(
  state: FetchedCurrencies = {},
  action: Object, // eslint-disable-line flowtype/no-weak-types
) {
  switch (action.type) {
    default:
      return state
  }
}

export const getCurrencies = (state: State) => state.currencies

export const getCurrenciesKeys: $FlowFixMe = createSelector(
  getCurrencies,
  Object.keys,
)
